"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicOrganizationMember = exports.getPublicOrganizationMembers = exports.putOrganizationMemberAccessibility = exports.deleteOrganizationMemberPermission = exports.postOrganizationMemberPermission = exports.delOrganizationMember = exports.postOrganizationMember = exports.putOrganizationMember = exports.getOrganizationMember = exports.getOrganizationMembers = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var organizationMembersAuthorizedPath = root_1.organizationManagementAuthorized + '/organizationMembers/';
var organizationMembersPublicPath = root_1.organizationManagementPublic + '/organizationMembers/';

var getOrganizationMembers = function getOrganizationMembers(authentication, queryParameters) {
  return common_1.get(authentication, organizationMembersAuthorizedPath, queryParameters);
};

exports.getOrganizationMembers = getOrganizationMembers;

var getOrganizationMember = function getOrganizationMember(authentication, id) {
  return common_1.get(authentication, organizationMembersAuthorizedPath + id);
};

exports.getOrganizationMember = getOrganizationMember;

var putOrganizationMember = function putOrganizationMember(authentication, organizationMember) {
  return common_1.put(authentication, organizationMembersAuthorizedPath + organizationMember.id, organizationMember);
};

exports.putOrganizationMember = putOrganizationMember;

var postOrganizationMember = function postOrganizationMember(authentication, organizationMember) {
  return common_1.post(authentication, organizationMembersAuthorizedPath, organizationMember);
};

exports.postOrganizationMember = postOrganizationMember;

var delOrganizationMember = function delOrganizationMember(authentication, id) {
  return common_1.del(authentication, organizationMembersAuthorizedPath + id);
};

exports.delOrganizationMember = delOrganizationMember;

var postOrganizationMemberPermission = function postOrganizationMemberPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, organizationMembersAuthorizedPath, id, permission);
};

exports.postOrganizationMemberPermission = postOrganizationMemberPermission;

var deleteOrganizationMemberPermission = function deleteOrganizationMemberPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, organizationMembersAuthorizedPath, id, permissionId);
};

exports.deleteOrganizationMemberPermission = deleteOrganizationMemberPermission;

var putOrganizationMemberAccessibility = function putOrganizationMemberAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, organizationMembersAuthorizedPath, id, accessibility);
};

exports.putOrganizationMemberAccessibility = putOrganizationMemberAccessibility;

var getPublicOrganizationMembers = function getPublicOrganizationMembers(authentication, queryParameters) {
  return common_1.get(authentication, organizationMembersPublicPath, queryParameters);
};

exports.getPublicOrganizationMembers = getPublicOrganizationMembers;

var getPublicOrganizationMember = function getPublicOrganizationMember(authentication, id) {
  return common_1.get(authentication, organizationMembersPublicPath + id);
};

exports.getPublicOrganizationMember = getPublicOrganizationMember;